import { useFeatureToggleV2Store } from '../store/featureToggleV2Store'
import { FeatureToggleV2Type } from '../enum/FeatureToggleType'

export function useFeatureToggleV2(feature: FeatureToggleV2Type): boolean {
  return useFeatureToggleV2Store(s => s.toggleListV2.has(feature))
}
